import { __assign, __extends, __rest } from "tslib";
import React, { Component } from 'react';
import DropdownItemSelectionManager from '../context/DropdownItemSelectionManager';
// HOC that typically wraps @atlaskit/item/ItemGroup
var withDropdownItemSelectionManager = function (WrappedComponent, selectionBehavior) {
    return /** @class */ (function (_super) {
        __extends(WithDropdownItemSelectionManager, _super);
        function WithDropdownItemSelectionManager() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithDropdownItemSelectionManager.prototype.render = function () {
            var _a = this.props, children = _a.children, id = _a.id, otherProps = __rest(_a, ["children", "id"]);
            return (React.createElement(WrappedComponent, __assign({}, otherProps),
                React.createElement(DropdownItemSelectionManager, { groupId: id, behavior: selectionBehavior }, children)));
        };
        return WithDropdownItemSelectionManager;
    }(Component));
};
export default withDropdownItemSelectionManager;
//# sourceMappingURL=withItemSelectionManager.js.map